module.exports = __webpack_public_path__ + "static/img/step-1.ff96305.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/step-1.png
// module id = t9Dh
// module chunks = 1